import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { Amplify } from "aws-amplify";
import Awsconfig from "./aws-exports";
import AwsconfigProduction from "./aws-exports-production";
import UserProvider from "./Components/UserProvider";
import "@mui/material/styles";
import 'bootstrap-icons/font/bootstrap-icons.css'
if (process.env.REACT_APP_ENV === "development") {
  Amplify.configure(Awsconfig);
} else {
  Amplify.configure(AwsconfigProduction);
}

ReactDOM.createRoot(document.getElementById("root")).render(
  <UserProvider>
    <App />
  </UserProvider>
);
if ("serviceWorker" in navigator) {
  navigator.serviceWorker
    .register("./firebase-messaging-sw.js")
    .then((registration) => {})
    .catch((error) => {
      console.error("Service Worker registration failed:", error);
    });
}

reportWebVitals();
